/**
 *
 * Organizations/Dashboard/RegistrationsChart
 *
 */

import React, { memo } from 'react'
// import PropTypes from 'prop-types'
// import styled from '@emotion/styled'

// import gql from 'graphql-tag'
// import useQuery from 'components/UseQuery'
// import { useMutation } from '@apollo/client'
import AmChartSerial from 'components/AmCharts/Serial'
import { COLORS } from 'global-styles'

function RegistrationsChart({ data, users, order_by_user }) {
	const graphs = users.map((user) => ({
		balloonText: '[[title]], [[category]]: <b>[[value]]</b>',
		fillAlphas: 1,
		id: `AmGraph-${user.id}`,
		title: user.full_name,
		type: 'column',
		valueField: user.full_name,
	}))

	if (graphs[0]) {
		graphs[0]['xAxis'] = 'ValueAxis-1'
		graphs[0]['yAxis'] = 'ValueAxis-1'
	}

	const config_user_graph = {
		categoryField: 'date',
		graphs,
		colors: [
			'#67bcdc',
			'#67dc98',
			'#dc67ce',
			'#6794dc',
			'#dc6788',
			'#dcd267',
			'#dcaf67',
			COLORS.purple,
			COLORS.warning,
			COLORS.success,
			COLORS.primary,
			COLORS.danger,
			COLORS.borderGrey,
			COLORS.grey,
		],
		dataProvider: data,
		chartScrollbar: {
			enabled: false,
		},
		valueScrollbar: {
			enabled: false,
		},
		legend: {
			spacing: 0,
			valueWidth: 10,
			// position: "absolute",
			// top: 200,
			// left: 0,
		},
	}

	const config_events_graphs = {
		categoryField: 'date',
		colors: ['#65357E', '#A886BA'],
		chartScrollbar: {
			enabled: false,
		},
		valueScrollbar: {
			enabled: false,
		},
		legend: false,
		graphs: [
			{
				balloonText: '[[title]] of [[category]]: <b>[[value]]</b>',
				fillAlphas: 1,
				id: 'AmGraph-1',
				title: 'Contacts',
				type: 'column',
				valueField: 'contacts',
				xAxis: 'ValueAxis-1',
				yAxis: 'ValueAxis-1',
			},
			{
				balloonText: '[[title]] of [[category]]: <b>[[value]]</b>',
				fillAlphas: 1,
				id: 'AmGraph-2',
				title: 'Guests',
				type: 'column',
				valueField: 'guests',
			},
		],
		dataProvider: data,
	}

	return order_by_user ? (
		<AmChartSerial config={config_user_graph} />
	) : (
		<AmChartSerial config={config_events_graphs} />
	)
}

RegistrationsChart.propTypes = {}

export default memo(RegistrationsChart)
